<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [user]="bookmark.refAuthor"
            [mode]="'avatar'"
          ></ngx-view-user-display>
        </div>

        <div class="content">
          <div class="content-header">
            <div>
              <ngx-view-user-display
                [user]="bookmark.refAuthor"
                [mode]="'name'"
              ></ngx-view-user-display>

              <h6 *ngIf="bookmark.refTitle" class="text-link">
                <nb-icon [icon]="bookmark.iconMode"></nb-icon>
                <a class="link" (click)="navigateRef(bookmark)">
                  {{ bookmark.refTitle }}
                </a>
              </h6>
            </div>
          </div>

          <div *ngIf="bookmark.refDescription" class="view-content">
            {{ bookmark.refDescription }}
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <button
        nbButton
        ghost
        shape="round"
        status="danger"
        size="small"
        class="action-button"
        [disabled]="loading"
        [class.btn-pulse]="loading"
        (click)="uncheck(bookmark)"
      >
        <nb-icon icon="trash-2-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
</nb-card>
